export default function HeadingOneIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.311"
      height="13.999"
      viewBox="0 0 17.311 13.999"
    >
      <g transform="translate(-632.66 -163.004)">
        <path
          fill="currentColor"
          d="M13345.351-3489.161v-6.411h-6.934v6.411h-1.888v-14h1.888v5.928h6.934v-5.928h1.887v14zm6.656 0v-7.554h-.088l-2.121 1.5v-1.7l2.209-1.585h1.833v9.33z"
          data-name="Union 34"
          transform="translate(-12703.869 3666.164)"
        ></path>
      </g>
    </svg>
  );
}
